import { Skeleton as SkeletonA } from 'antd';
import cs from 'classnames';
import type { ComponentProps } from 'react';
import styles from './skeleton.module.css';

export type SkeletonProperties = ComponentProps<typeof SkeletonA>;

const Skeleton = ({ classNames, ...props }: SkeletonProperties) => (
  <SkeletonA
    classNames={
      typeof classNames === 'function'
        ? (info) => {
            const resolvedClassNames = classNames(info);

            return {
              ...resolvedClassNames,
              title: cs(styles['ui-skeleton-title'], resolvedClassNames?.title),
            };
          }
        : { ...classNames, title: cs(styles['ui-skeleton-title'], classNames?.title) }
    }
    {...props}
  />
);

Skeleton.Avatar = SkeletonA.Avatar;
Skeleton.Button = SkeletonA.Button;
Skeleton.Input = SkeletonA.Input;
Skeleton.Image = SkeletonA.Image;
Skeleton.Node = SkeletonA.Node;

export default Skeleton;
